import { useMemo } from "react";

import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	guestPostalCode: string;
	guestAddress: string;
};

export const BasicInfoGuestAddressOfPrintComposition = ({ guestPostalCode, guestAddress }: Props) => {
	const guestAddressText = useMemo(() => {
		return `〒 ${guestPostalCode} ${guestAddress}`;
	}, [guestAddress, guestPostalCode]);

	return <PrintBasicInfoTableLayout title="ご住所" content={guestAddressText} />;
};
